export default "__VITE_ASSET__6f4cbf16__"